import * as yup from "yup";
import moment from "moment";

const isValidObjectWithId = (value) =>
  value &&
  typeof value === "object" &&
  (typeof value.id === "string" || typeof value.id === "number") &&
  value.id !== "";

const today = new Date();
today.setHours(0, 0, 0, 0);

const minDate = new Date();
minDate.setDate(minDate.getDate() - 3);
minDate.setHours(0, 0, 0, 0);

export const validationSchema = yup.object().shape({
  // conceptoFactura: yup
  //   .string()
  //   .required("Ingrese el concepto de la carta porte"),

  fecha: yup
    .date()
    .test("is-valid", "La fecha no puede ser mayor a hoy", (value) =>
      value ? moment(value).isSameOrBefore(moment(), "day") : false
    )
    .test("is-min", "La fecha no puede ser menor a hace 3 días", (value) =>
      value
        ? moment(value).isSameOrAfter(moment().subtract(3, "days"), "day")
        : false
    )
    .required("Seleccione una fecha"),

  folio: yup.string().required("Seleccione un folio"),

  serie: yup.string().required("Seleccione una serie"),

  paymentFormId: yup
    .mixed()
    .test("is-selected", "Seleccione una forma de pago", isValidObjectWithId)
    .required("Seleccione una forma de pago"),

  paymentMethodId: yup
    .mixed()
    .test("is-selected", "Seleccione un método de pago", isValidObjectWithId)
    .required("Seleccione un método de pago"),

  customerId: yup
    .mixed()
    .test("is-selected", "Seleccione un cliente", isValidObjectWithId)
    .required("Seleccione un cliente"),

  cfdiId: yup
    .mixed()
    .test("is-selected", "Seleccione un CFDI", isValidObjectWithId)
    .required("Seleccione un CFDI"),

  fiscalRegimeId: yup
    .mixed()
    .test("is-selected", "Seleccione un régimen fiscal", isValidObjectWithId)
    .required("Seleccione un régimen fiscal"),

  conceptosFacturaTabla: yup
    .array()
    .of(
      yup.object().shape({
        cantidad: yup
          .number()
          .required("La cantidad es requerida")
          .typeError("La cantidad debe ser un número")
          .moreThan(0, "La cantidad debe ser mayor a 0"),

        productKey: yup
          .mixed()
          .test(
            "productKey",
            "La clave del producto es requerida",
            isValidObjectWithId
          )
          .required("La clave del producto es requerida"),

        unitKey: yup
          .mixed()
          .test("unitKey", "La unidad es requerida", isValidObjectWithId)
          .required("La unidad es requerida"),

        precioUnitario: yup
          .number()
          .required("El precio unitario es requerido")
          .typeError("El precio unitario debe ser un número")
          .moreThan(0, "El precio unitario debe ser mayor a 0"),

        iva: yup
          .number()
          .typeError("El IVA debe ser un número")
          .min(0, "El IVA no puede ser negativo"),

        total: yup
          .number()
          .required("El total es requerido")
          .typeError("El total debe ser un número")
          .moreThan(0, "El total debe ser mayor a 0"),

        Descripcion: yup.string().required("La descripción es requerida"),

        needRetention: yup.boolean(),
        
      })
    )
    .min(1, "Debes agregar al menos un concepto a la factura"),
});

export const initialValues = {
  conceptoFactura: "",
  fecha: "",
  folio: "",
  serie: "",
  paymentFormId: null,
  paymentMethodId: null,
  customerId: null,
  cfdiId: null,
  fiscalRegimeId: null,

  // Conceptos
  conceptosFacturaTabla: [],
};
